import React from "react";
import styles from "./Input.module.css";

interface SelectOption {
  value: any;
  label: string;
}

interface SelectInputProps {
  value: any;
  options: SelectOption[];
  name: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
  value,
  onChange,
  options,
  name,
}) => {
  return (
    <select className={styles.singleInput} value={value} onChange={onChange}>
      <option value="">
        Choose {name}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectInput;
